import { Spinner } from '@/components';

export function VideoBufferingOverlay() {
    return (
        <div className="pointer-events-none absolute inset-0 z-[2] flex items-center justify-center bg-black-100/30">
            <Spinner size={48} />
        </div>
    );
}
